// PlayerContext.js
'use strict';
import React from 'react';

export const PlayerContext = React.createContext({
  player: null,
  setPlayer: () => undefined,
});
